import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";

import { useNewsAdmin } from "../../hooks/admin/user/useNewsAdmin";
import { newsService } from "../../services/news.service";

export default function NewsManagement() {
  const [page, setPage] = useState(1);

  const {
    news,
    loading,
    pagination,
    refetch,
  } = useNewsAdmin(page, 10);

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Bạn có chắc muốn xóa bài viết này?"
    );

    if (!confirmed) return;

    try {
      await newsService.deleteNews(id);

      await refetch();
    } catch (error) {
      console.error("Delete News Error:", error);
    }
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">
          Quản lý Tin tức
        </h1>

        <Link
          to="/admin/news/create"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
        >
          <FaPlus />
          Thêm bài viết
        </Link>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-4 text-left">Ảnh</th>
              <th className="p-4 text-left">Tiêu đề</th>
              <th className="p-4 text-left">Danh mục</th>
              <th className="p-4 text-left">Tác giả</th>
              <th className="p-4 text-left">Trạng thái</th>
              <th className="p-4 text-left">Lượt xem</th>
              <th className="p-4 text-left">Ngày tạo</th>
              <th className="p-4 text-center">Thao tác</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-8"
                >
                  Đang tải...
                </td>
              </tr>
            ) : news.length === 0 ? (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-8"
                >
                  Chưa có bài viết nào
                </td>
              </tr>
            ) : (
              news.map((item) => (
                <tr
                  key={item.id}
                  className="border-t hover:bg-gray-50"
                >
                  <td className="p-4">
                    <img
                      src={item.thumbnail}
                      alt={item.title}
                      className="w-20 h-14 object-cover rounded"
                    />
                  </td>

                  <td className="p-4 font-medium">
                    {item.title}
                  </td>

                  <td className="p-4">
                    {item.category}
                  </td>

                  <td className="p-4">
                    {item.author}
                  </td>

                  <td className="p-4">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${
                        item.status === "published"
                          ? "bg-green-100 text-green-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {item.status === "published"
                        ? "Đã đăng"
                        : "Bản nháp"}
                    </span>
                  </td>

                  <td className="p-4">
                    {item.views}
                  </td>

                  <td className="p-4">
                    {new Date(
                      item.createdAt
                    ).toLocaleDateString("vi-VN")}
                  </td>

                  <td className="p-4">
                    <div className="flex justify-center gap-3">
                      <Link
                        to={`/admin/news/edit/${item.id}`}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <FaEdit />
                      </Link>

                      <button
                        onClick={() =>
                          handleDelete(item.id)
                        }
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-6">
          {Array.from({
            length: pagination.totalPages,
          }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setPage(idx + 1)}
              className={`px-4 py-2 rounded ${
                page === idx + 1
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}